import { CUSTOM_COLORS } from '../content/parties';
import { colorProblem } from '../engine/colors';

/** Parteifarbe frei wählen: Farbwähler plus Vorschläge. Warnt bei zu ähnlichen, zu hellen oder zu dunklen Farben. */
export function ColorPicker({ id, value, onChange, abbr, skip, extra = [] }: {
  id: string; value: string; onChange: (c: string) => void; abbr?: string; skip?: string; extra?: { n: string; c: string }[];
}) {
  const problem = colorProblem(value, skip, extra);
  return (
    <div className="param colorpick">
      <label className="label" htmlFor={id}>Farbe</label>
      <div className="cprow">
        <input type="color" id={id} value={value} onChange={(e) => onChange(e.target.value)} aria-describedby={id + '-hint'} />
        <span className="cpprev" style={{ background: value }} aria-hidden="true">{(abbr || '').trim().slice(0, 5) || 'Abc'}</span>
        <span className="cpsugg" role="group" aria-label="Vorschläge">
          {CUSTOM_COLORS.filter((x) => !colorProblem(x, skip, extra)).map((x) => (
            <button type="button" key={x} className="cpsw" aria-pressed={value.toLowerCase() === x} aria-label={`Farbe ${x}`} title={x} onClick={() => onChange(x)} style={{ background: x }} />
          ))}
        </span>
      </div>
      <span id={id + '-hint'} className={'sub' + (problem ? ' down' : '')}>{problem || 'Klick auf das Farbfeld öffnet den Farbwähler. Die Farbe erscheint auf Karte, Sitzverteilung und in allen Grafiken.'}</span>
    </div>
  );
}
